module.exports = __webpack_public_path__ + "static/media/virgen-de-la-soledad.27b36629.jpg";